import React from "react";
import { LicitacaoDetailsPage } from "./licitacaoDetails.page";
import { LicitacaoDetailsProvider } from "./context/licitacao-details-context";

export function LicitacaoDetailsFactory() {
    return (
        <LicitacaoDetailsProvider>
            <LicitacaoDetailsPage />
        </LicitacaoDetailsProvider>
    );
}
